"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASS_EMPTY = exports.CLASS_HIDDEN = exports.CLASS_OPEN = void 0;
exports.CLASS_OPEN = 'is-open';
exports.CLASS_HIDDEN = 'is-hidden';
exports.CLASS_EMPTY = 'is-empty';
